import { useMemo } from 'react';
import { useMutation, useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL, ICustomPageContactInfoDto } from '@/dtos';
import {
  ContactResponseModel,
  CreateContactDto,
} from '@/modules/employer/components/SetupEmployer/ContactsSecurity/AddEditContactsSecurityModal/ContactSecurity.types';

export enum ContactQueryNames {
  CONTACT_LIST = 'contactList',
}

export const DEFAULT_PAGE_SIZE = 10;

interface Props {
  search?: string;
  organizationId?: string;
  size?: number;
  permissionsIds?: Array<number | undefined>;
  triggerRefetching?: string;
  page?: number;
  enabled?: boolean;
}

export const useContactListQuery = (props?: Props) => {
  const query = useQuery(
    [
      ContactQueryNames.CONTACT_LIST,
      props?.search,
      props?.organizationId,
      props?.size,
      props?.permissionsIds,
      props?.triggerRefetching,
      props?.page,
      props?.enabled,
    ],
    () =>
      api.get<ICustomPageContactInfoDto>(API_URL.CONTACTS_ALL, {
        params: {
          ...(props?.search ? { search_value: props?.search } : {}),
          ...(props?.size && props.size !== DEFAULT_PAGE_SIZE ? { size: props?.size } : {}),
          ...(props?.organizationId ? { organization_id: props?.organizationId } : {}),
          ...(props?.permissionsIds?.length
            ? { type: props?.permissionsIds ? props?.permissionsIds?.join(',') : '' }
            : {}),
          ...(props?.page ? { page: props?.page } : {}),
        },
      }),
    { enabled: props?.enabled }
  );

  const formatedList = useMemo(() => {
    const list = (query.data?.data?.content || query.data?.data) as ContactResponseModel[];
    return list?.map((item) => ({
      ...item,
      roleId: `${item.role_id}`,
    }));
  }, [query.data]);
  return {
    ...query,
    contactList: formatedList || [],
    // TODO: clarify the field usage
    // @ts-ignore
    totalElements: query.data?.data?.total_elements || query.data?.data?.totalElements,
  };
};

export const useAddContactMutation = () =>
  useMutation((value: CreateContactDto) => api.post(API_URL.CONTACTS, value));

export const useUpdateContactMutation = (contactId?: string) =>
  useMutation((value: ContactResponseModel) => api.put(API_URL.CONTACTS_BY_CONTACT_ID(contactId || ''), value));
